<template>
    <div id="media-controls-container">
        <AddCandidateButton />
        <AddMatchButton />
        <div class="group-separator"></div>
        <ApplyGradeFromButton />
        <div class="group-separator"></div>
        <ShowSplitViewButton :class="{'v-btn--active': splitView }" />
        <div class="group-separator"></div>
        <AssignRatingButton />
        <AssignStatusButton />
        <AssignColourButton />
        <div class="group-separator"></div>
        <RotateMediaButton />
        <ResetSceneButton />
    </div>
</template>


<script>
import AssignStatusButton from "@/components/app/buttons/AssignStatusButton.vue";
import AssignRatingButton from "@/components/app/buttons/AssignRatingButton.vue";
import AssignColourButton from "@/components/app/buttons/AssignColourButton.vue";
import ApplyGradeFromButton from "@/components/app/buttons/ApplyGradeFromButton.vue";
import ResetSceneButton from "@/components/app/buttons/ResetSceneButton.vue";
import RotateMediaButton from "@/components/app/buttons/RotateMediaButton.vue";
import ShowSplitViewButton from "@/components/app/buttons/ShowSplitViewButton.vue";
import { mapState } from "vuex";
import AddMatchButton from "@/components/app/buttons/AddMatchButton.vue";
import AddCandidateButton from "@/components/app/buttons/AddCandidateButton.vue";

export default {
    components: {
        AddCandidateButton, AddMatchButton,
        ResetSceneButton,
        RotateMediaButton,
        ShowSplitViewButton,
        ApplyGradeFromButton,
        AssignColourButton,
        AssignRatingButton,
        AssignStatusButton
    },

    computed: {
        ...mapState('UI', ['splitView'])
    }
}
</script>

<style lang="scss" scoped>
#media-controls-container {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    display: flex;
    align-items: center;
    gap: 8px;

    ::v-deep .v-btn {
        min-width: auto;
        height: auto;
        padding: 0;
        box-shadow: none;
        background-color: transparent;
        color: var(--font-default-color);
        padding: 3px;

        &--active {
            &::before {
                background-color: var(--color-accent);
                opacity: 0.4;
            }
        }

        &--disabled,
        &--disabled .v-icon {
            background-color: transparent !important;
            color: var(--font-default-color) !important;
            opacity: 0.4;
        }

        i {
            font-size: 1.7rem;
        }
    }

    .group-separator {
        width: 1px;
        height: 24px;
        background: var(--color-group-separator);
        margin: 0 10px;
    }
}
</style>